import { useEffect } from "react";
import { api } from "@/lib/api";
import { initGoogleAds } from "@/lib/ads";

// Carrega a configuração de integrações públicas e inicializa a tag do Google Ads
// uma única vez (quando ativa em Painel > Integrações). Não renderiza nada.
export default function GoogleAds() {
  useEffect(() => {
    api.get("/public/integrations")
      .then(({ data }) => initGoogleAds(data?.google_ads))
      .catch(() => {});
  }, []);
  return null;
}
